import { useState } from "react";
import { useLocation } from "react-router-dom";
import Contact from "../Utils/Contact";
import "./Footer.css";

const Footer = () => {
  const [openContact, setOpenContact] = useState(false);
  const location = useLocation();

  const hostname = window.location.hostname.toLowerCase();

  const isGuestopsy =
    hostname.includes("guestopsy.com") ||
    (hostname === "localhost" &&
      new URLSearchParams(location.search).get("site") === "guestopsy");

  const brandName = isGuestopsy ? "GuestOpsy" : "HostelandPG";

  return (
    <>
      <footer className="footer">
        <div className="footer-content">

          {/* LEFT */}
          <div className="footer-left">
            <p className="copyright">
              &copy; {new Date().getFullYear()} {brandName}. All rights
              reserved.
            </p>

            <p className="address">
              Narayanapura Main Road, Hennur, Bangalore – 560077
            </p>

            <p className="support-number">
              Support:
              <br />
              <a href="tel:+919567433148">+91 9567433148</a>
              <br />
              <a href="tel:+918904088225">+91 8904088225</a>
            </p>
          </div>

          {/* RIGHT */}
          <div className="footer-links">
            <span>Privacy Policy</span>
            <span>Terms of Service</span>
          </div>

        </div>
      </footer>

      {/* CONTACT POPUP */}
      <Contact
        open={openContact}
        onClose={() => setOpenContact(false)}
      />
    </>
  );
};

export default Footer;